import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
/**
 * 清空回收站
 */
export var ClearTrashRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(ClearTrashRequest, _DriveRequest);
  var _super = _createSuper(ClearTrashRequest);
  function ClearTrashRequest() {
    _classCallCheck(this, ClearTrashRequest);
    return _super.apply(this, arguments);
  }
  _createClass(ClearTrashRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/trash_clear',
        data: null,
        params: {
          xsrf: getXsrfToken()
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'ClearTrashResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return true;
    }
  }]);
  return ClearTrashRequest;
}(DriveRequest);
//# sourceMappingURL=clear-trash.js.map